<script setup lang="ts">
import model from '@/ts/model.ts';
import { getLangText } from '@/ts/utils/utils.ts';
import searchIcon from '@/assets/search.svg?raw';
import { showGameFilter } from '@/ts/management/game-filter-management.ts';

function onClick(){
    if(model.gameFilter.displayed){
        model.dispatch('ResetFilter');
        return;
    }

    showGameFilter(true);
}

</script>

<template>
    <div class="nav-item" @click.prevent.stop="onClick()" :class="{active: model.gameFilter.displayed}">
        <div class="icon" v-html="searchIcon"></div>
        <div class="name">{{ getLangText('SearchLabel', undefined, 'mobile-nav-bottom') }}</div>
    </div>
</template>

<style lang="scss" scoped>
@use './nav-item.scss';
</style>